import { ContextMenuMESFProvider } from "@dexteel/mesf-core";
import { ProcesssDataReportPage } from "./ProcessDataReportPage";
import { ProcesssReportProvider } from "./context/ProcesssDataReportContext";

type Props = {};
const EAFProcessDataReport = (props: Props) => {
	return (
		<ContextMenuMESFProvider>
			<ProcesssReportProvider>
				<ProcesssDataReportPage />
			</ProcesssReportProvider>
		</ContextMenuMESFProvider>
	);
};
export default EAFProcessDataReport;
